import { render, staticRenderFns } from "./MrLoans.vue?vue&type=template&id=08ecbd2c&scoped=true&"
import script from "./MrLoans.vue?vue&type=script&lang=js&"
export * from "./MrLoans.vue?vue&type=script&lang=js&"
import style0 from "./MrLoans.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MrLoans.vue?vue&type=style&index=1&id=08ecbd2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecbd2c",
  null
  
)

export default component.exports